import auth from '@/api/auth'
import users from "@/api/users";

export default {
    namespaced: true,
    state: {
        user: null,
        loggedIn: false
    },
    getters: {},
    actions: {
        fetchUser ({ commit }) {
            return new Promise((resolve, reject) => {
                users.get().then(response => {
                    commit('setUser', response.data)
                    commit('setLoggedIn', true)
                    resolve(response)
                }).catch(error => reject(error));
            })
        },
        updateUser({commit, state}, data) {
            return new Promise((resolve, reject) => {
                users.update(state.user.id, data).then(() => {
                    commit('updateUser', data)
                    resolve()
                }).catch(error => reject(error))
            })
        },
        loggedIn ({ commit }) {
            commit('setLoggedIn', true)
        },
        logout ({ commit }) {
            commit('setUser', null)
            commit('setLoggedIn', false)
            return auth.logout()
        },
        logUser ({ commit }, user) {
            commit('setUser', user)
            commit('setLoggedIn', true)
        }
    },
    mutations: {
        setUser (state, user) {
            state.user = user
        },
        setLoggedIn (state, value) {
            state.loggedIn = value
        },
        updateUser(state, data) {
            Object.keys(data).forEach(key => {
                state.user[key] = data[key]
            })
        }
    }
}